import { CollectionPage, OfferCatalog } from 'schema-dts';
import { JsonLd } from './JsonLD';

function CollectionPageSchema(props: { pageProps: any; locale?: string }) {
  const { pageProps } = props;
  const collectionPage: CollectionPage =
    props?.locale === 'en'
      ? {
          '@type': 'CollectionPage',
          name: 'Check out the Best Real Estate Egypt Offers - Nawy',
          image: 'https://www.nawy.com/assets/icons/common/nawy.svg',
          description:
            'Explore the best real estate Egypt offers & discounts, from the top developers in various compounds. Get your home with Nawy with the best prices & deals',
          url: 'https://www.nawy.com/real-estate-offers',
          mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': 'https://www.nawy.com/real-estate-offers'
          }
        }
      : {
          '@type': 'CollectionPage',
          name: 'اكتشف أفضل عروض عقارية في مصر والحصرية من ناوي - Nawy',
          image: 'https://www.nawy.com/assets/icons/common/nawy.svg',
          description:
            'سواء كنت مستثمرًا عقاريًا، أو حتى تبحث عن منزلك، أو ربما وحدة لتبدأ أعمالك؛ اعرف أفضل عروض عقارية  في مصر، وانتهز الفرصة وبادر بالشراء بأفضل خطط الدفع والسداد!',
          url: 'https://www.nawy.com/ar/real-estate-offers',
          mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': 'https://www.nawy.com/ar/real-estate-offers'
          }
        };

  const offerCatalog: OfferCatalog =
    props?.locale === 'en'
      ? {
          '@type': 'OfferCatalog',
          name: 'Exclusive Offers & Discounts from Nawy Real Estate',
          description:
            'Exclusive property offers including up to 10-year installment plans with 0% down payment, instant cash discounts, cashback deals, and flexible payment options.',
          url: 'https://www.nawy.com/real-estate-offers',
          numberOfItems: pageProps?.initialOffers?.length || 0,
          image: 'https://www.nawy.com/assets/icons/common/nawy.svg'
        }
      : {
          '@type': 'OfferCatalog',
          name: 'عروض وخصومات حصرية من ناوي للعقارات',
          description:
            'عروض حصرية تتنوع بين تقسيط حتى 10 سنوات بدون مقدم، خصومات فورية عند الدفع الكاش، استرداد نقدي، وخطط سداد مرنة ومتنوعة',
          url: 'https://www.nawy.com/ar/real-estate-offers',
          numberOfItems: pageProps?.initialOffers?.length || 0,
          image: 'https://www.nawy.com/assets/icons/common/nawy.svg'
        };

  return JsonLd<CollectionPage>('collectionPage-schema', {
    '@context': 'https://schema.org',
    ...collectionPage,
    mainEntity: offerCatalog
  });
}

export default CollectionPageSchema;
